export default class Lead {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  dni: string;
  city: string;
  province: string;
  address: string;
  number: string;
  portal: string;
  stair: string;
  floor: string;
  door: string;
  CUPS: string;
  constructor(
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    dni: string,
    city: string,
    province: string,
    address: string,
    number: string,
    portal: string,
    stair: string,
    floor: string,
    door: string,
    CUPS: string
  ) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phone = phone;
    this.dni = dni;
    this.city = city;
    this.province = province;
    this.address = address;
    this.number = number;
    this.portal = portal;
    this.stair = stair;
    this.floor = floor;
    this.door = door;
    this.CUPS = CUPS;
  }

  public toJSONObject() {
    return {
      FirstName: this.firstName,
      LastName: this.lastName,
      Street: this.getStreet(),
      State: this.province,
      City: this.city,
      email: this.email,
      Phone: this.phone,
      GEO_CUPS__c: this.CUPS,
      GEO_Cupon__c: null
    };
  }

  private getStreet() {
    let street = this.address;
    if (this.number) {
      street += `, Numero ${this.number}`;
    }
    if (this.portal) {
      street += `, Portal ${this.portal}`;
    }
    if (this.stair) {
      street += `, Escalera ${this.stair}`;
    }
    if (this.floor) {
      street += `, Piso ${this.floor}`;
    }
    if (this.door) {
      street += `, Puerta ${this.door}`;
    }
    return street;
  }
}
